// extracted by mini-css-extract-plugin
module.exports = {"col-md-4":"Security_col-md-4__eo4CO","aBlockTitle":"Security_aBlockTitle__gKf_O","aTitle":"Security_aTitle__uBwBD","oSecuritySectionBlock":"Security_oSecuritySectionBlock__v9mOJ"};